import request from "@/plugins/axios/request";

//通过id查询单独文章 findbycategoryid
export function queryById(appInfo) {
    return request({
        url: "/zparticle/findbyid",
        method: "post",
        data: appInfo
    });
}
//查询文章
export function listTitle(appInfo) {
    return request({
        url: "/zparticle/querypagearticle",
        method: "post",
        data: appInfo
    });
}
